import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../assets/logo.png';
import { Search, Heart, ClipboardList, User, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const navItems = [
  { to: '/',                    icon: Search,        label: 'Rechercher un logement' },
  { to: '/client/favoris',      icon: Heart,         label: 'Mes favoris' },
  { to: '/client/reservations', icon: ClipboardList, label: 'Mes réservations' },
  { to: '/client/profil',       icon: User,          label: 'Mon profil' },
];

export default function ClientSidebar() {
  const { logout, userProfile } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    toast.success('Déconnecté');
    navigate('/');
  }

  return (
    <aside style={{
      position: 'fixed',
      top: 0, left: 0, bottom: 0,
      width: 'var(--sidebar-width)',
      background: 'var(--primary)',
      display: 'flex',
      flexDirection: 'column',
      zIndex: 100,
      boxShadow: '4px 0 20px rgba(0,0,0,0.1)',
    }}>
      {/* Logo */}
      <div style={{ padding: '1.5rem 1.25rem', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <img src={logo} alt="ResiPro CI" style={{ width: 40, height: 40, borderRadius: 10, objectFit: 'contain', background: 'white', padding: 2 }} />
          <div>
            <div style={{ color: 'white', fontFamily: 'Poppins', fontWeight: 700, fontSize: '1rem' }}>ResiPro CI</div>
            <span style={{ background: '#2980b9', color: 'white', fontSize: '0.65rem', fontWeight: 700, padding: '1px 8px', borderRadius: 20, letterSpacing: '0.05em' }}>CLIENT</span>
          </div>
        </div>
      </div>

      {/* User info */}
      {userProfile && (
        <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.78rem' }}>Connecté en tant que</div>
          <div style={{ color: 'white', fontWeight: 600, fontSize: '0.9rem', marginTop: 2 }}>
            {userProfile.prenom} {userProfile.nom}
          </div>
        </div>
      )}

      {/* Nav */}
      <nav style={{ flex: 1, padding: '0.75rem', display: 'flex', flexDirection: 'column', gap: '0.25rem', overflowY: 'auto' }}>
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink key={to} to={to} style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: '0.75rem',
            padding: '0.7rem 0.75rem', borderRadius: 8,
            color: isActive ? 'white' : 'rgba(255,255,255,0.65)',
            background: isActive ? 'rgba(255,255,255,0.15)' : 'transparent',
            fontWeight: isActive ? 600 : 400, fontSize: '0.9rem',
            transition: 'all 0.2s', textDecoration: 'none',
          })}>
            <Icon size={18} />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Signature */}
      <div style={{ padding: '0.5rem 1.25rem', textAlign: 'center' }}>
        <p style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '0.04em', lineHeight: 1.6 }}>
          <span style={{ fontWeight: 700, color: 'rgba(255,255,255,0.5)' }}>KONSTRUCT</span> by Constant<br />Powered by AI
        </p>
      </div>

      {/* Logout */}
      <div style={{ padding: '0.75rem' }}>
        <button onClick={handleLogout} style={{
          display: 'flex', alignItems: 'center', gap: '0.75rem',
          padding: '0.7rem 0.75rem', borderRadius: 8, width: '100%',
          color: 'rgba(255,255,255,0.65)', background: 'transparent',
          border: 'none', cursor: 'pointer', fontSize: '0.9rem', transition: 'all 0.2s',
        }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(231,76,60,0.3)'; e.currentTarget.style.color = 'white'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'rgba(255,255,255,0.65)'; }}
        >
          <LogOut size={18} />
          Déconnexion
        </button>
      </div>
    </aside>
  );
}
